
export default {
  name: 'MattressesRoute',
  layout(context) {
    return context.app.store.state.user_agent === 'Googlebot' ? 'google' : 'default';
  },
};
